import CodeType from '@/models/codeType'

export default {
  namespaced: true,
  actions: {
    list () {
      var results = {}
      var codeTypes = [
        { id: 'c_id', name: 'Container number' },
        { id: 'b_id', name: 'Booking number' },
        { id: 'm_bl', name: 'B/L number' }
      ]

      codeTypes.forEach(
        element => {
          results[element.id] = new CodeType(element)
        }
      )
      return Promise.resolve(results)
    },
    arrayList () {
      var codeTypes = [
        { id: 'c_id', name: 'Container number' },
        { id: 'b_id', name: 'Booking number' },
        { id: 'm_bl', name: 'B/L number' }
      ]
      return Promise.resolve(codeTypes)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/codeType.js